import { I18nextProvider } from "react-i18next";
import { i18n } from "./i18n";

export interface I18nProviderProps {
  children: React.ReactNode;
}

/**
 * I18nProvider — binds the package's configured i18next instance into the React tree.
 * Apps import this and useTranslation; they never touch i18next directly (ADR-0013).
 */
export function I18nProvider({ children }: I18nProviderProps) {
  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
}
